export const concatStrings = (str1, str2, char = ";") => {
    if (str1 && str2) {
        return str1.concat(char, str2);
    }

    if (str1) {
        return str1
    }
    if (str2) {
        return str2
    }

    return ""
}